import { PaginationInterface, PaginationResource } from './Pagination';

export const transformToPagination = (resource: PaginationResource): PaginationInterface => ({
    total: resource.total,
    page: resource.page,
    pageSize: resource.pageSize,
    pageCount: resource.pageCount,
});
